import axios from 'axios';
import { saveFailed, saveStarted, saveSucceeded } from './saveTracker';

const instance = axios.create();

// Every write reports whether it reached the server (27 Oct 2026).
instance.interceptors.request.use(saveStarted);
instance.interceptors.response.use(saveSucceeded, saveFailed);

/*
 * AN EXPIRED SESSION ENDS ON THE LOGIN PAGE, WHATEVER ASKED (21 Oct 2026).
 *
 * Most requests reach errorRequestHandler, which logs out on a 401. Eleven
 * screens call the API directly and catch their own failures — «Дублікати
 * профілів» among them, which read an «Expired JWT Token» as «no duplicates»
 * and stayed on the page. So the rule lives here, once: a 401 to a request
 * that CARRIED a token means the session is over. A request sent without one
 * — the login itself, a public screen — is not a session that expired.
 *
 * The handler is registered by the app (App.js) — this module cannot import
 * the store without a cycle — and errorRequestHandler's own guard makes the
 * logout happen once, however many requests fail together.
 */
let sessionExpired = null;

export const whenSessionExpires = handler => {
    sessionExpired = handler;
};

const carriedToken = config => {
    const headers = (config && config.headers) || {};

    return Boolean(headers.Authorization || headers.authorization);
};

/** The interceptor's error branch — named, so it can be tested on its own. */
export const endExpiredSession = error => {
    if (error && error.response && 401 === error.response.status && carriedToken(error.config) && sessionExpired) {
        sessionExpired();
    }

    return Promise.reject(error);
};

instance.interceptors.response.use(response => response, endExpiredSession);

export default instance;
